export default __webpack_public_path__ + "static/media/pumpkin2.41237ee7.png";